import React, { ChangeEvent } from "react";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

import { useLoggedInUser } from "components/LoggedInUserProvider";
import TableCellWrapper from "components/VetExamsTable/TableCellWrapper";
import { transformViewDate } from "utils/date-utils";
import FlagPriority from "./FlagPriority";

import useStyles from "./styles";

interface IProps {
  flag: racehorse360.IWorkoutRequestFlag | racehorse360.IUpcomingRaceEntryFlag;
  facility: racehorse360.IFacility;
  onChangePriority: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
  selectedButtonTitle?: string;
  defaultButtonTitle?: string;
}

const FlagCell = (props: IProps) => {
  const {
    flag,
    facility,
    onChangePriority,
    selectedButtonTitle,
    defaultButtonTitle,
    ...restProps
  } = props;

  const classes = useStyles();
  const { currentUser } = useLoggedInUser();

  const userId = currentUser.rh360Id;

  const handleChangePriority = async (event: ChangeEvent<HTMLInputElement>) => {
    await onChangePriority(event);
  };

  const renderContent = () => {
    const isOwner = userId === flag?.flaggedBy?.id;

    if (flag && !isOwner) {
      return (
        <span className={classes.flaggedInfo} data-test-id={"flaggedInfo"}>
          {`Dr. ${flag.flaggedBy.lastName} ${transformViewDate(
            flag.flaggedOn,
            facility?.timezone
          )}`}
        </span>
      );
    }

    return (
      <FlagPriority
        priority={flag?.priority}
        selectedButtonTitle={selectedButtonTitle}
        defaultButtonTitle={defaultButtonTitle}
        onChangePriority={handleChangePriority}
      />
    );
  };

  return <TableCellWrapper {...restProps}>{renderContent()}</TableCellWrapper>;
};

export default React.memo(FlagCell);
